import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-local-jobs',
  template: `
    <app-navigation-secondary-local-jobs></app-navigation-secondary-local-jobs>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryLocalJobsComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/compat/compat-navigation-secondary-local-jobs.component.ts